










































































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import {
  EmailHistoryEvent,
  EmailHistoryEventSource
} from "@/employer/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import EmailHistoryRawEvent from "@/employer/components/partner-ee-service/EmailHistoryRawEvent.vue";
import Button from "@/shared/components/ui/Button.vue";
import moment from "moment";
import { useNotifierStore } from "@/shared/store/notifier";
import { useEmailHistoryStore } from "@/employer/store/emailHistory";

const RemoveFromBounceListTimeoutSeconds = 30;

@Component({
  components: {
    GenericLoadingSpinner,
    Button,
    EmailHistoryRawEvent
  }
})
export default class EmailHistory extends Vue {
  notifierStore = useNotifierStore();
  emailHistoryStore = useEmailHistoryStore();

  @Prop()
  email: string;

  moment = moment;
  isSubmitting = false;
  searchEmail = null;
  selectedMessageId = null;
  removeFromBounceListTimeout = false;
  showRawEventModal = false;
  selectedRecord: EmailHistoryEvent = null;

  mounted () {
    if (this.email) {
      this.searchEmail = this.email;
      this.onSearch();
    }
  }

  get isSearchDisabled () {
    return this.isSubmitting === true || !this.isFormValid || this.emailHistoryStore.isLoading;
  }

  get isFormValid () {
    return !this.$validator.errors.any();
  }

  get isRemoveFromBounceListDisabled () {
    return !this.isFormValid || this.removeFromBounceListTimeout;
  }

  get isRemoveFromBounceListShown () {
    if (this.emailHistoryStore.history.length < 1) {
      return false;
    }

    const latestDropped = this.emailHistoryStore.history.findIndex(
        e => e.source === EmailHistoryEventSource.Okta && e.bounceType === "dropped");
    const latestSuccess = this.emailHistoryStore.history.findIndex(
        e => e.source === EmailHistoryEventSource.Okta && e.diagnosticCode === "SUCCESS");

    return latestDropped > -1 && (latestSuccess === -1 || latestDropped < latestSuccess);
  }

  get removeFromBounceListTooltip () {
    return this.removeFromBounceListTimeout
        ? `Please wait ${RemoveFromBounceListTimeoutSeconds} seconds before trying this again.`
        : "";
  }

  onSearch () {
    if (this.isSubmitting) return;
    this.$validator
        .validate()
        .then(result => {
          if (!result) return;
          this.isSubmitting = true;
          return this.emailHistoryStore.loadHistory(this.searchEmail)
              .catch(err => {
                this.onSearchError(err);
              });
        })
        .finally(() => this.isSubmitting = false);
  }

  onSearchError (err) {
    this.notifierStore.setDanger(err.message);
    this.isSubmitting = false;
  }

  onHover (record: EmailHistoryEvent, active: boolean) {
    if (active) {
      this.selectedMessageId = record.sesMessageId;
    } else if (this.selectedMessageId === record.sesMessageId) {
      this.selectedMessageId = null;
    }
  }

  onDetailClick (record: EmailHistoryEvent) {
    this.selectedRecord = record;
    this.showRawEventModal = true;
  }

  onRemoveFromBounceList () {
    this.$validator
        .validate()
        .then(isValid => {
          if (!isValid) {
            return;
          }

          this.removeFromBounceListTimeout = true;
          this.emailHistoryStore.removeFromBounceList(this.searchEmail);

          setTimeout(() => {
            this.removeFromBounceListTimeout = false;
          }, RemoveFromBounceListTimeoutSeconds * 1000);
        });
  }
}
